import { JobStatusBookingPipe } from './transaction-center.jobs.status-booking.pipe';

export function JobStatusBooking ( jobStatusBookingPipe : JobStatusBookingPipe ) {
  return ( value : string ) : string => jobStatusBookingPipe.transform(value);
}